<input class="hidden" type="file" accept="image/*" (change)="uploadFiles($event)" #imgSelect>
<div class="image-capture-button" (click)="imgSelect.click()">
	<mat-icon aria-hidden="false" aria-label="Upload">upload</mat-icon>
	<span>Upload Image</span>
</div>